module.exports = __webpack_public_path__ + "img/menu.e1666543.svg";